module.exports = __webpack_public_path__ + "img/youtube.1a153441.svg";